import React, { useEffect } from 'react'
import { useSpaceIdFromPathname } from 'hooks/useSpaceInfoFromPathname'

import { useAppProgressStore } from './store/appProgressStore'
import { AppProgressState } from './AppProgressState'

export const AppProgressOverlayTrigger = (props: {
    progressState: AppProgressState
    debugSource: string
}) => {
    const { setAppProgressOverlay, setOptimisticSpaceInitialized } = useAppProgressStore()

    const spaceId = useSpaceIdFromPathname()

    useEffect(() => {
        setAppProgressOverlay(props.progressState)
        return () => {
            setAppProgressOverlay(AppProgressState.None)
        }
    }, [props.progressState, setAppProgressOverlay])

    useEffect(() => {
        if (spaceId && props.progressState === AppProgressState.InitializingWorkspace) {
            return () => {
                setOptimisticSpaceInitialized(spaceId, true)
            }
        }
    }, [props.progressState, setOptimisticSpaceInitialized, spaceId])
    return <></>
}
